import { datadogLogs } from "@datadog/browser-logs";
import { useContext } from "react";

import { datadogContext } from "./datadog-context";

export function useDatadog() {
  return useContext(datadogContext) ?? datadogLogs;
}
